module.exports = __webpack_public_path__ + "img/pro_s2_icon10.07a187c7.png";